import React from 'react'

const TelecallerLab = () => {
  return (
    <div>TelecallerLab</div>
  )
}

export default TelecallerLab